export default function RequestQuoteSection() {
  return (
    <section
      className="w-full py-20 px-6 flex flex-col items-center text-center relative overflow-hidden"
      style={{ backgroundColor: "#012E72" }}
    >
      {/* Subtle grid texture */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          backgroundImage:
            "repeating-linear-gradient(90deg, rgba(255,255,255,0.03) 0px, rgba(255,255,255,0.03) 1px, transparent 1px, transparent 80px), repeating-linear-gradient(0deg, rgba(255,255,255,0.03) 0px, rgba(255,255,255,0.03) 1px, transparent 1px, transparent 80px)",
        }}
      />

      {/* Soft radial glow behind content */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            "radial-gradient(ellipse 70% 60% at 50% 50%, rgba(0,45,181,0.35) 0%, transparent 100%)",
        }}
      />

      {/* Content */}
      <div className="relative flex flex-col items-center gap-5 max-w-2xl">

        {/* Heading */}
        <h2
          className="font-cinzel font-bold text-white-pure uppercase"
          style={{
            fontSize: "clamp(22px, 4vw, 36px)",
            letterSpacing: "0.08em",
            lineHeight: "1.15",
          }}
        >
          Still Have Questions?
        </h2>

        {/* Decorative rule */}
        <div className="flex items-center gap-3">
          <div className="h-px w-12 bg-white-pure opacity-20" />
          <div className="w-1 h-1 rounded-full bg-white-pure opacity-30" />
          <div className="h-px w-12 bg-white-pure opacity-20" />
        </div>

        {/* Subtext */}
        <p
          className="font-constantia text-white-pure opacity-75 leading-relaxed"
          style={{ fontSize: "clamp(15px, 2vw, 17px)" }}
        >
          If you didn't find the answer you were looking for, we're here to help.
        </p>

        {/* Buttons */}
        <div className="flex flex-wrap justify-center gap-4 mt-2">
          <button
            className="font-constantia font-bold text-blue-dark bg-white-pure px-8 py-3 rounded-full transition-all duration-200 hover:bg-white-warm hover:shadow-lg"
            style={{ fontSize: "15px", letterSpacing: "0.02em" }}
          >
            Request a Quote
          </button>

          <button
            className="font-constantia font-bold text-white-pure border border-white-pure border-opacity-50 px-8 py-3 rounded-full transition-all duration-200 hover:bg-white-pure hover:bg-opacity-10 hover:border-opacity-80"
            style={{ fontSize: "15px", letterSpacing: "0.02em" }}
          >
            Contact Us Directly
          </button>
        </div>
      </div>
    </section>
  );
}